module.exports = __webpack_public_path__ + "static/media/Icon-K.e9923b7f.svg";